import styled from 'styled-components'
import { Calendar } from 'Components/atoms'
import CircularProgress from '@material-ui/core/CircularProgress'
import colors from 'Assets/colors'
import { media } from 'Config/styled'

export const Container = styled.div`
  input[type='number']::-webkit-outer-spin-button,
  input[type='number']::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type='number'] {
    -moz-appearance: textfield;
  }

  padding: 2.5rem 1.25rem 9rem;
  height: calc(100vh - 168px);
  overflow: auto;
  scrollbar-gutter: stable;

  ${media('lg')} {
    padding: 0 0 9rem;
  }
`

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding-bottom: 1rem;

  ${media('lg')} {
    height: 56px;
    padding-bottom: 0;
  }
`

export const BackButton = styled.button`
  display: none;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  flex-shrink: 0;

  ${media('lg')} {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`

export const Title = styled.div`
  font-family: Inter;
  font-style: normal;
  font-weight: bold;
  font-size: 32px;
  line-height: 40px;

  ${media('lg')} {
    display: flex;
    align-items: center;
    font-size: 20px;
    line-height: 10px;
  }
`

export const SubTitle = styled.div`
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: ${colors.black};

  ${media('lg')} {
    display: none;
  }
`

export const MobileStickyHeader = styled.div`
  ${media('lg')} {
    position: sticky;
    top: 0;
    z-index: 10;
    background: ${colors.white};
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
    padding: 0 1.25rem 8px;
  }
`

export const MobileProviderCard = styled.div`
  display: none;

  ${media('lg')} {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 2px;
    background: ${colors.black};
    height: 56px;
    padding: 0 1.25rem;
    margin: 0 -1.25rem;
  }
`

export const MobileProviderCardName = styled.div`
  font-family: Inter;
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0;
  vertical-align: middle;
  color: ${colors.white};
`

export const MobileProviderCardOrder = styled.div`
  font-family: Inter;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0;
  color: ${colors.white};
`

export const RequestedContainer = styled.div`
  padding: 1rem 0 1.5rem;

  ${media('lg')} {
    padding: 8px 1.25rem 0;
  }
`

export const SingleRequestedContainer = styled.div`
  border: 1px solid rgba(51, 51, 51, 0.24);
  border-radius: 8px;

  ${media('lg')} {
    border: none;
    border-radius: 0;
  }
`

export const RequestedHeader = styled.div`
  background: ${colors.black};
  color: ${colors.white};
  padding: 8px 16px;
  border-radius: 8px 8px 0px 0px;
  display: flex;
  justify-content: space-between;

  ${media('lg')} {
    display: none;
  }
`

export const RequestedHeaderInfo = styled.div`
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
`

export const RequestedProviderInfoContainer = styled.div`
  background: ${colors.gray98b};
  padding: 16px;
  display: flex;
  justify-content: space-between;

  ${media('lg')} {
    display: none;
  }
`

export const RequestedProviderInfo = styled.div`
  display: flex;
  justify-content: flex-start;
  > * {
    margin-right: 8px;
  }

  ${media('lg')} {
    flex-direction: column;
    align-items: flex-start;
  }
`

export const RequestedProviderName = styled.div`
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: ${colors.black};
`

export const RequestedProviderDeliveryDate = styled.div`
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  color: ${colors.black};
  background: ${colors.cart};
  border-radius: 8px;
  padding: 0 8px;
`

export const RequestedProviderOrderNumber = styled.div`
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 24px;
  color: ${colors.gray40l};
`

export const ProviderDetail = styled.div`
  display: flex;
  align-items: center;
  font-family: Inter;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  color: ${props => props.theme.colors.black};
`

export const TotalPrice = styled.span`
  margin-right: 24px;
`

export const TotalProductLines = styled.span`
  font-family: Inter;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0%;
  vertical-align: middle;
`

export const ProductsContainer = styled.div`
  border-top: 1px solid rgba(51, 51, 51, 0.24);
  padding: 0 16px 16px;
  background: ${colors.gray98b};

  ${media('lg')} {
    padding: 0;
    background: transparent;
    border-top: none;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
`

export const ProductHeader = styled.div`
  display: grid;
  grid-template-columns: 34% 15% 15% 15% 15% 6%;
  padding: 16px;

  ${media('lg')} {
    display: none;
  }
`

export const StatusNameComboHeader = styled.div`
  display: grid;
  grid-template-columns: 18% 82%;
`

export const ProductHeaderItem = styled.div`
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: ${colors.black};
  padding-left: 16px;
  &:first-child {
    padding-left: 0;
  }
`

export const ProductContainer = styled.div`
  display: grid;
  grid-template-columns: 34% 15% 15% 15% 15% 6%;
  background: ${colors.white};
  border: 1px solid rgba(51, 51, 51, 0.24);
  box-sizing: border-box;
  border-radius: 8px;
  padding: 11px 16px;
  margin-bottom: 16px;
  align-items: ${props => (props.expanded ? 'flex-start' : 'center')};
  ${props =>
    props.expanded &&
    !props.isExtraService &&
    `
    > *:not(:first-child):not(:last-child) {
      margin-top: 10px;
    }
    > *:last-child {
      margin-top: 15px;
    }
  `}
  &:last-child {
    margin-bottom: 0;
  }

  ${media('lg')} {
    grid-template-columns: 1fr auto;
    row-gap: 0;
    column-gap: 8px;
    padding: 16px;
    margin-bottom: 0;

    ${props =>
      props.isExtraService
        ? `
      > *:not(:first-child):not(:nth-child(2)):not(:nth-child(3)):not(:last-child) {
        grid-column: 1 / -1;
        margin-top: 9px;
      }
      > *:nth-child(3) {
        grid-column: 1;
      }
    `
        : `
      > *:not(:first-child):not(:nth-child(2)):not(:last-child) {
        grid-column: 1 / -1;
        margin-top: 9px;
      }
    `}
    > *:last-child {
      margin-top: 0;
    }
  }
`

export const StatusNameCombo = styled.div`
  display: grid;
  grid-template-columns: 18% 82%;
  height: 100%;
  align-items: center;

  ${media('lg')} {
    border-right: none;
    grid-template-columns: 1fr;
    grid-column: 1;
    grid-row: 1;
    ${props => props.isExtraService && 'grid-column: 1 / -1;'}
  }
`

export const SingleFieldContainer = styled.div`
  padding-left: 16px;

  ${media('lg')} {
    padding-left: 0;
    ${props =>
      props.inline &&
      `
      display: flex;
      align-items: baseline;
      gap: 4px;
      grid-column: 1;
      grid-row: 2;
    `}
    ${props =>
      props.isExtraService &&
      `
      display: flex;
      align-items: baseline;
      gap: 4px;
    `}
  }
`

export const ProductName = styled.div`
  font-family: Inter;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  color: ${colors.black};
  padding-right: 24px;

  ${media('lg')} {
    font-weight: 600;
    font-size: 16px;
    line-height: 20.63px;
    letter-spacing: -0.23px;
    color: #333333;
    padding-right: 0;
  }
`

export const ExtraServiceNameBadge = styled.div`
  display: inline-flex;
  align-items: center;
  width: 110px;
  height: 18px;
  border-radius: 4px;
  background: #ffd600;
  padding: 0 6.5px;
  margin-bottom: 2px;
  font-family: Inter;
  font-weight: 700;
  font-style: normal;
  font-size: 10px;
  line-height: 20px;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #333333;
  white-space: nowrap;
  overflow: hidden;

  ${media('lg')} {
    width: 100%;
    font-size: 12px;
    justify-content: center;
  }
`

export const FixedInputField = styled.div`
  background: ${colors.grayInputLight};
  border-radius: 8px;
  height: 40px;
  padding: 8px 16px;
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: ${colors.black};

  ${media('lg')} {
    background: transparent;
    border-radius: 0;
    height: auto;
    padding: 0;
    font-weight: 600;
    font-size: 14px;
    line-height: 16px;
    letter-spacing: 0;
    color: #333333;
  }
`

export const ActionContainer = styled.div`
  background: ${colors.gray98b};
  box-shadow: 0px -2px 18px 0px rgba(0, 0, 0, 0.24), 0px 0px 2px 0px rgba(0, 0, 0, 0.12);
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  padding: 16px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;

  ${media('lg')} {
    flex-direction: column;
    align-items: stretch;
    gap: 0.5rem;
    padding: 12px 16px;
  }
`

export const DateSelectorContainer = styled.div`
  display: flex;
  align-items: center;
  position: relative;

  ${media('lg')} {
    flex: 1;
  }
`

export const DatePickerButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 196px;
  height: 44px;
  border-radius: 8px;
  background: ${colors.grayInputEditable};
  border: none;
  padding: 0 12px;
  cursor: pointer;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.8;
  }

  ${media('lg')} {
    width: 100%;
    height: 40px;
  }
`

export const DatePickerText = styled.span`
  font-family: Inter;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.15px;
  color: ${props => (props.hasValue ? colors.textPrimary : colors.textSecondary)};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const WarningDateContainer = styled.div`
  font-family: Inter;
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 14px;
  color: ${colors.red};
  margin-bottom: -6px;
`

export const FooterInputsRow = styled.div`
  display: contents;

  ${media('lg')} {
    display: flex;
    gap: 8px;
    width: 100%;
  }
`

export const TextInputContainer = styled.div`
  display: flex;
  align-items: center;

  ${media('lg')} {
    flex: 1;

    label {
      height: 40px;
    }

    input {
      height: 40px;
      padding: 0 1rem;
    }
  }
`

export const FinishButtonContainer = styled.div`
  display: flex;
  align-items: center;

  ${media('lg')} {
    width: 100%;
  }
`

export const FinishButton = styled.div`
  pointer-events: ${props => (props.disabled ? 'none' : 'auto')};
  width: 411px;
  height: 44px;

  ${media('lg')} {
    width: 100%;
    height: 40px;
    padding: 0 22px;
    justify-content: center;
  }
  background-color: ${props => (props.disabled ? colors.grayDisabled : colors.green)};
  padding: 8px 22px;
  display: flex;
  justify-content: flex-end;
  font-family: Inter;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  color: ${colors.black};
  border-radius: 8px;
  cursor: pointer;
  align-items: center;
  transition: all 0.2s;

  &:hover {
    opacity: 0.8;
    transform: translateY(-2px);
    box-shadow: 0 3px 5px rgba(51, 51, 51, 0.2);
  }

  &:active {
    transform: translate(-1px);
    box-shadow: 0 1px 3px rgba(51, 51, 51, 0.4);
  }
`

export const TotalsContainer = styled.div`
  display: flex;
  align-items: center;
`

export const TotalsTotalPrice = styled.div`
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: ${props => (props.disabled ? colors.black : colors.white)};

  ${media('lg')} {
    white-space: nowrap;
  }
`

export const NumberValueSpan = styled.span`
  font-family: Inter;
  font-weight: ${props => (props.disabled ? '600' : '700')};
  font-size: 16px;
  line-height: ${props => (props.disabled ? '24px' : '32px')};
  letter-spacing: 0;
  font-variant-numeric: lining-nums proportional-nums;

  ${media('lg')} {
    font-weight: 700;
  }
`

export const TotalsTotalItems = styled.div`
  background: #ffffff;
  border-radius: 4px;
  padding: 0px 8px;
  margin-left: 1rem;
  font-family: Inter;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0;
  font-variant-numeric: lining-nums proportional-nums;
  color: ${colors.black};
`

export const ButtonLiteral = styled.div`
  font-family: Inter;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0;
  text-align: center;
  vertical-align: middle;
  font-variant-numeric: lining-nums proportional-nums;
  color: ${props => (props.disabled ? colors.black : colors.white)};
  margin-right: auto;

  ${props => props.disabled && `${media('lg')} { display: none; }`}
`

export const StyledCalendar = styled(Calendar)`
  position: absolute;
  bottom: 62px;
  right: 0;
  background: ${colors.white};
  width: 330px;
  max-width: none;

  ${media('lg')} {
    bottom: 54px;
    right: unset;
  }
`

export const CircularProgressStyled = styled(CircularProgress)`
  margin-right: 10px;
  &.MuiCircularProgress-colorPrimary {
    color: ${colors.white};
  }
`

export const LabelMobile = styled.div`
  display: none;

  ${media('lg')} {
    display: block;
    font-family: Inter;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0;
    color: #666666;
  }
`

export const SearchInputWrapper = styled.div`
  label {
    .icon-input {
      right: auto;
      left: 1rem;
    }

    input {
      padding-left: 2.5rem;
    }

    .close-input-icon {
      right: 1rem;
      width: 14px;
      height: 14px;
      color: #2d3139;
      top: 50%;
      bottom: auto;
      transform: translateY(-50%);
    }
  }

  ${media('lg')} {
    flex: none;
    width: 100%;

    label {
      height: 40px;

      .icon-input {
        top: 50%;
        bottom: auto;
        transform: translateY(-50%);
      }

      input {
        height: 40px;
        padding-left: 2.5rem;
        padding-right: 2.5rem;
      }

      .close-input-icon {
        top: 50%;
        bottom: auto;
        transform: translateY(-50%);
      }
    }
  }
`

export const SearchAndCounterRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 1rem 0 0;

  ${media('lg')} {
    flex-direction: column-reverse;
    align-items: flex-start;
    margin: 0;
    gap: 0;
  }
`

export const ReviewedCounterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
  ${media('lg')} {
    width: 100%;
    flex-direction: row;
    align-items: center;
    gap: 16px;
  }
`

export const ReviewedProgressTrack = styled.div`
  width: 100%;
  height: 4px;
  background: ${colors.green}33;
  border-radius: 2px;
  overflow: hidden;

  ${media('lg')} {
    width: 100%;
    flex-shrink: 1;
    min-width: 0;
    margin: 13px 0;
  }
`

export const ReviewedProgressBar = styled.div`
  height: 100%;
  width: ${props => props.progress || '0%'};
  background: ${colors.green};
  border-radius: 2px;
  transition: width 0.3s ease;
`

export const ReviewedCount = styled.span`
  font-family: Inter;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0;
  color: #666666;
  white-space: nowrap;
`

export const ReviewedText = styled.span`
  font-family: Inter;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0;
  color: #666666;
  white-space: nowrap;

  ${media('lg')} {
    white-space: nowrap;
  }
`

export const ReviewCheckWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 1rem;

  ${media('lg')} {
    padding: 0;
    justify-content: center;
    grid-column: 2;
    grid-row: 1 / 3;
    align-self: start;

    ${props =>
      props.isExtraService &&
      `
      grid-row: 2 / 4;
      align-self: center;
    `}

    ${LabelMobile} {
      display: none;
    }
  }
`

export const ReviewCheckButton = styled.button`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: ${props => (props.checked ? 'none' : '2px solid #666666')};
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  padding: 0;
  overflow: hidden;
  transition: border-color 0.2s, opacity 0.2s;

  &:hover {
    opacity: 0.8;
  }
`

export const DetailExtraService = styled.div`
  background: #ffffff;
  margin-right: 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 2px;
  overflow: hidden;
`

export const ExtraServiceRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
`

export const ExtraServiceLabel = styled.span`
  font-family: Inter;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0;
  color: #666666;
  white-space: nowrap;
  min-width: 88px;
  padding-top: 1px;
`

export const ExtraDescWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  flex: 1;
  min-width: 0;
`

export const ExtraDesc = styled.div`
  display: ${props => (props.expanded ? 'block' : '-webkit-box')};
  -webkit-line-clamp: ${props => (props.expanded ? 'unset' : '1')};
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0;
  color: ${colors.black};
  flex: 1;

  ${media('lg')} {
    margin-bottom: 0;
    margin-top: 0;
  }
`

export const ExpandToggle = styled.button`
  flex-shrink: 0;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  align-self: flex-start;
  color: ${colors.black};
  display: flex;
  -webkit-appearance: none;
`

export const ExtraMobileDetalleRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const ExtraMobilePrecioRow = styled.div`
  display: flex;
  gap: 16px;

  > * {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 2px;
  }
`

export const TitleME = styled.div`
  font-family: Inter;
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 32px;
  padding-bottom: 1rem;
  margin-top: 1rem;
`

export const Message = styled.div`
  font-family: Inter;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  color: ${props => props.theme.colors.black};
  text-align: center;
  padding-bottom: 1.5rem;
`

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
`

export const ProductPriceRow = styled.div`
  display: contents;

  ${props =>
    props.expanded &&
    `
    > * {
      margin-top: 10px;
    }
  `}

  ${media('lg')} {
    display: flex;
    gap: 8px;
    grid-column: 1 / -1;
    margin-top: 9px;

    > * {
      flex: 1;
      min-width: 0;
      margin-top: 0;
    }
  }
`

export const Cancel = styled.div`
  width: 100%;
  padding: 1rem;
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: ${props => props.theme.colors.black};
  border: 2px solid #333333;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;

  :hover {
    color: ${props => props.theme.colors.white};
    background-color: ${props => props.theme.colors.black};
  }
`
